// services/productApiService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_QWIK_MEDIC_API_URL;
const TOKEN = process.env.REACT_APP_QWIK_MEDIC_TOKEN;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const productApiService = {
  // Get all products
  getAllProducts: async () => {
    try {
      const response = await axiosInstance.get('product/');
      return response.data.reverse(); // Show latest first
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  // Update product MRP only
  updateProductMRP: async (id, mrp) => {
    try {
      const response = await axiosInstance.patch(`product/${id}`, {
        mrp: mrp
      });
      return response.data;
    } catch (error) {
      console.error('Error updating product MRP:', error);
      throw error;
    }
  },

  // Delete product
  deleteProduct: async (id) => {
    try {
      await axiosInstance.delete(`product/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting product:', error);
      throw error;
    }
  },

  // Search products
  searchProducts: async (query) => {
    try {
      const response = await axiosInstance.get('product/');
      const allProducts = response.data;

      // Client-side filtering for search
      return allProducts.filter(product =>
        product.productname.toLowerCase().includes(query.toLowerCase()) ||
        product.productbrand.toLowerCase().includes(query.toLowerCase()) ||
        product.category.toLowerCase().includes(query.toLowerCase()) ||
        product.vandor.toLowerCase().includes(query.toLowerCase())
      );
    } catch (error) {
      console.error('Error searching products:', error);
      throw error;
    }
  },
};